export function ready(fn) {
	if (document.readyState === 'complete') {
		return fn();
	}

	document.addEventListener('DOMContentLoaded', fn, false);
}

export function one(selector, root = document) {
	return root.querySelector(selector);
}

export function all(selector, root = document) {
	return Array.from(root.querySelectorAll(selector));
}
